import { generatePrefixedTagName } from '../generate-prefixed-tag-name';
import { safelyDefineCustomElement } from '../safely-define-custom-element';

import styleText from './index.scss';

export class MwAppletLoader extends HTMLElement {
    static get tagName() {
        return generatePrefixedTagName`mw-applet-loader`;
    }

    constructor() {
        super();
        this.__root = this.attachShadow({mode: 'open'});
    }

    connectedCallback() {
        this.__root.innerHTML = `
            <style>
                ${styleText}
            </style>
            <div class="mw-applet-loader">
                <div class="mw-applet-loader__drop"></div>
                <div class="mw-applet-loader__circle1"></div>
                <div class="mw-applet-loader__circle2"></div>
            </div>
        `;
    }
}

safelyDefineCustomElement(MwAppletLoader);
